export default "__VITE_ASSET__BwxmX0yJ__"